import { render, staticRenderFns } from "./OtaOrderResyncButton.vue?vue&type=template&id=b183c636&scoped=true&"
import script from "./OtaOrderResyncButton.vue?vue&type=script&lang=js&"
export * from "./OtaOrderResyncButton.vue?vue&type=script&lang=js&"
import style0 from "./OtaOrderResyncButton.vue?vue&type=style&index=0&id=b183c636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b183c636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b183c636')) {
      api.createRecord('b183c636', component.options)
    } else {
      api.reload('b183c636', component.options)
    }
    module.hot.accept("./OtaOrderResyncButton.vue?vue&type=template&id=b183c636&scoped=true&", function () {
      api.rerender('b183c636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/finance/OtaOrderResyncButton.vue"
export default component.exports